import { render, staticRenderFns } from "./AppSearchList.vue?vue&type=template&id=bec5b778&scoped=true"
import script from "./AppSearchList.vue?vue&type=script&lang=js"
export * from "./AppSearchList.vue?vue&type=script&lang=js"
import style0 from "./AppSearchList.vue?vue&type=style&index=0&id=bec5b778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec5b778",
  null
  
)

export default component.exports